import { useQueryState } from "nuqs";
import { Box, Tab, Tabs as MuiTabs, Badge } from "@mui/material";

type TabsValues = {
  key: string;
  label: React.ReactNode;
  content: React.ReactNode;
  badgeCount?: number;
};

type TabsProps = {
  queryKey: string;
  values: TabsValues[];
};

const Tabs: React.FC<TabsProps> = (props) => {
  const { queryKey, values } = props;

  const [currentTab, setCurrentTab] = useQueryState(queryKey, { defaultValue: values[0].key });
  const currentTabContent = values.find((tab) => tab.key === currentTab)?.content;

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <MuiTabs
          value={currentTab}
          onChange={(_, value) => setCurrentTab(value)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {values.map((tab) => (
            <Tab
              key={tab.key}
              value={tab.key}
              label={
                <>
                  {tab.label}
                  <Badge
                    color="primary"
                    badgeContent={tab.badgeCount}
                    sx={{
                      display: !tab.badgeCount ? "none" : "block",
                      position: "static",
                      "& .MuiBadge-badge": {
                        position: "static",
                        transform: "none",
                      },
                    }}
                  />
                </>
              }
              sx={(theme) => ({
                justifyContent: "start",
                [theme.breakpoints.up("sm")]: {
                  flexDirection: "row",
                  gap: 1,
                },
                ":not(.Mui-selected)": { opacity: !tab.badgeCount ? 0.5 : 1 },
              })}
            />
          ))}
        </MuiTabs>
      </Box>

      {currentTabContent}
    </>
  );
};

export default Tabs;
